/*
  Vehicle picker helpers shared by sections/vehicle-filter.liquid and
  sections/vehicle-fit.liquid.

  Data: window.SP_VEHICLES from assets/vehicle-data.js (generated by fitment.py)
    [[brand, brandSlug, [[model, modelSlug, [[engine, engineSlug], ...]], ...]], ...]

  Availability: window.SP_FACETS from assets/vehicle-index.js (fitment.py) -
  which models / engines have active products per kategorie / podkategorie /
  vyrobce. Models and engines are numbered in the order of SP_VEHICLES.

  Product tags (written by fitment.py):
    fit-<brand>                     fits at least one model of the brand
    fit-<brand>-<model>             fits at least one engine of the model
    fit-<brand>-<model>-<engine>    fits that engine
*/
(function () {
  if (window.SPVehicle) return;

  var STORAGE_KEY = 'sp_vehicle';

  function data() {
    return window.SP_VEHICLES || [];
  }

  /* give every model / engine its global number (same order as fitment.py) */
  var numbered = false;
  function number() {
    if (numbered) return;
    var mi = 0, ei = 0;
    data().forEach(function (b) {
      b[2].forEach(function (m) {
        m.b = b[1];
        m.no = mi++;
        m.eno = ei;
        ei += m[2].length;
      });
    });
    numbered = true;
  }

  var decoded = {};
  function bits(b64) {
    if (!decoded[b64]) {
      var s = atob(b64), a = new Uint8Array(s.length);
      for (var i = 0; i < s.length; i++) a[i] = s.charCodeAt(i);
      decoded[b64] = a;
    }
    return decoded[b64];
  }
  function has(set, n) { return !!(set[n >> 3] & (1 << (n & 7))); }

  /*
    sel: {cat, sub, manu} - selected filter values ('' = any)
    -> {model(m) -> bool, engine(m, k) -> bool} or null when no index is loaded
  */
  function available(sel) {
    number();
    var f = window.SP_FACETS;
    if (!f) return null;
    var want = {};
    ['cat', 'sub', 'manu'].forEach(function (d, i) {
      var v = (sel && sel[d] || '').trim().toLowerCase();
      want[i] = v ? f.dims[d].map(function (x) { return x.toLowerCase() === v; }) : null;
    });
    var models = null, engines = null;
    f.rows.forEach(function (r) {
      for (var i = 0; i < 3; i++) if (want[i] && !want[i][r[i]]) return;
      var ms = bits(r[3]), es = bits(r[4]);
      if (!models) { models = new Uint8Array(ms.length); engines = new Uint8Array(es.length); }
      for (var j = 0; j < ms.length; j++) models[j] |= ms[j];
      for (var k = 0; k < es.length; k++) engines[k] |= es[k];
    });
    return {
      model: function (m) { return !!models && has(models, m.no); },
      engine: function (m, k) { return !!engines && has(engines, m.eno + k); }
    };
  }

  /*
    Categories that have active products for a car.
    v: {b, m, e} slugs (m / e optional)
    -> [{cat, subs: [sub, ...]}, ...] in index order, or null when no index is loaded
  */
  function categoriesFor(v) {
    var f = window.SP_FACETS;
    if (!f || !v || !v.b) return null;
    number();
    var b = brand(v.b);
    if (!b) return [];
    var models = v.m ? b[2].filter(function (m) { return m[1] === v.m; }) : b[2];
    var engineNo = null;
    if (v.m && v.e && models[0]) {
      models[0][2].forEach(function (e, k) { if (e[1] === v.e) engineNo = models[0].eno + k; });
    }
    var out = [], byCat = {};
    f.rows.forEach(function (r) {
      var hit = engineNo !== null
        ? has(bits(r[4]), engineNo)
        : models.some(function (m) { return has(bits(r[3]), m.no); });
      if (!hit) return;
      var cat = f.dims.cat[r[0]], sub = f.dims.sub[r[1]];
      if (!cat) return;
      if (!byCat[cat]) { byCat[cat] = { cat: cat, subs: [] }; out.push(byCat[cat]); }
      if (sub && byCat[cat].subs.indexOf(sub) < 0) byCat[cat].subs.push(sub);
    });
    return out;
  }

  function brand(bs) {
    return data().find(function (b) { return b[1] === bs; }) || null;
  }

  function model(bs, ms) {
    var b = brand(bs);
    return (b && b[2].find(function (m) { return m[1] === ms; })) || null;
  }

  function engine(bs, ms, es) {
    var m = model(bs, ms);
    return (m && m[2].find(function (e) { return e[1] === es; })) || null;
  }

  /* {b, m, e} slugs -> 'fit-...' tag of the most specific level chosen */
  function tag(v) {
    if (!v || !v.b) return '';
    return 'fit-' + [v.b, v.m, v.m && v.e].filter(Boolean).join('-');
  }

  /* 'fit-...' tag -> {b, m, e} slugs, or null */
  function fromTag(t) {
    if (!t || t.indexOf('fit-') !== 0) return null;
    var rest = t.slice(4);
    var list = data();
    for (var i = 0; i < list.length; i++) {
      var b = list[i];
      if (rest === b[1]) return { b: b[1], m: '', e: '' };
      if (rest.indexOf(b[1] + '-') !== 0) continue;
      var r2 = rest.slice(b[1].length + 1);
      for (var j = 0; j < b[2].length; j++) {
        var m = b[2][j];
        if (r2 === m[1]) return { b: b[1], m: m[1], e: '' };
        if (r2.indexOf(m[1] + '-') !== 0) continue;
        var r3 = r2.slice(m[1].length + 1);
        for (var k = 0; k < m[2].length; k++) {
          if (m[2][k][1] === r3) return { b: b[1], m: m[1], e: r3 };
        }
      }
    }
    return null;
  }

  function label(v) {
    if (!v) return '';
    var b = brand(v.b), m = v.m && model(v.b, v.m), e = v.e && engine(v.b, v.m, v.e);
    return [b && b[0], m && m[0], e && e[0]].filter(Boolean).join(' ');
  }

  function getGarage() {
    try {
      var v = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      return v && brand(v.b) ? v : null;
    } catch (err) {
      return null;
    }
  }

  function setGarage(v) {
    try {
      if (v && v.b) localStorage.setItem(STORAGE_KEY, JSON.stringify({ b: v.b, m: v.m || '', e: v.e || '' }));
      else localStorage.removeItem(STORAGE_KEY);
    } catch (err) { /* private mode etc. */ }
    document.dispatchEvent(new CustomEvent('sp:vehicle-change', { detail: getGarage() }));
  }

  /* Current vehicle in the URL: /collections/x/fit-...  or  ?filter.p.tag=fit-... */
  function fromUrl() {
    var seg = decodeURIComponent(location.pathname.split('/').pop() || '');
    var tags = seg.split('+');
    new URLSearchParams(location.search).getAll('filter.p.tag').forEach(function (t) { tags.push(t); });
    for (var i = 0; i < tags.length; i++) {
      var v = fromTag(tags[i]);
      if (v) return v;
    }
    return null;
  }

  function fill(select, items, placeholder, selected) {
    select.innerHTML = '';
    var first = document.createElement('option');
    first.value = '';
    first.textContent = placeholder;
    select.appendChild(first);
    items.forEach(function (it) {
      var o = document.createElement('option');
      o.value = it[1];
      o.textContent = it[0];
      select.appendChild(o);
    });
    select.value = items.some(function (it) { return it[1] === selected; }) ? selected : '';
    select.disabled = !items.length;
  }

  /*
    Wires three <select>s together.
    opts: {brand, model, engine, placeholders: {brand, model, engine, none},
           initial: {b, m, e}, allow: () => available(...) or null}
    Returns {get: () => {b, m, e}, set: (v) => void, refresh: () => void}
  */
  function bind(opts) {
    var ph = opts.placeholders || {};
    var bSel = opts.brand, mSel = opts.model, eSel = opts.engine;
    var allowOf = opts.allow || function () { return null; };

    function render(v) {
      var allow = allowOf();
      var brands = data().filter(function (b) {
        return !allow || b[2].some(allow.model);
      });
      fill(bSel, brands, brands.length ? ph.brand || 'Značka' : ph.none || 'Žádné vozy', v.b);
      var b = brand(bSel.value);
      var models = b ? b[2].filter(function (m) { return !allow || allow.model(m); }) : [];
      fill(mSel, models, ph.model || 'Model', v.m);
      var m = model(bSel.value, mSel.value);
      var engines = m ? m[2].filter(function (e, k) { return !allow || allow.engine(m, k); }) : [];
      fill(eSel, engines, ph.engine || 'Motorizace', v.e);
      if (!bSel.value) mSel.disabled = true;
      if (!mSel.value) eSel.disabled = true;
    }

    function get() { return { b: bSel.value, m: mSel.value, e: eSel.value }; }

    bSel.addEventListener('change', function () { render({ b: bSel.value }); });
    mSel.addEventListener('change', function () { render({ b: bSel.value, m: mSel.value }); });

    render(opts.initial || {});

    return {
      get: get,
      set: render,
      refresh: function () { render(get()); }
    };
  }

  window.SPVehicle = {
    data: data, brand: brand, model: model, engine: engine,
    tag: tag, fromTag: fromTag, fromUrl: fromUrl, label: label, available: available, categoriesFor: categoriesFor,
    getGarage: getGarage, setGarage: setGarage, bind: bind
  };
})();
